var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window white"},[(!_vm.swapbtc || (_vm.swapbtc && !_vm.loaded))?_c('deposit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }